"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELegalCapacityTrads = void 0;
exports.ELegalCapacityTrads = {
    majeur_capable: "Majeur capable",
    majeur_sous_protection: "Majeur sous protection",
    mineur: "Mineur",
};
